import {Component, Input, ViewChild, ViewEncapsulation} from '@angular/core';
import { ButtonTriggerEvent } from '../../../common/components';
import { HubPlace } from '../../../models/hub/hub.place';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { AlertifyService } from "../../../services/alertify.service";
import { ToggleAndDataSourceStore } from '../../../stores/hub.calendar.store';
import {LocalStorageService} from "../../../services/localStorageService";
import {PlaceType} from "../place.category/customize.place.category.component";
import {EditPlaceCategoryModalActions} from "./edit.place.category.modal.provider";
import {PlaceCategorySelectorComponent} from "./place.category.selector/place.category.selector.component";
import {HubVisitorToggleDataSource} from "../../../models/hub/hub.visitor.feature.toggle";
import {PlaceService} from "../../../services/place.service";
import {VisitorApiService} from "../../../services/visitor.api.service";

@Component({
    templateUrl: './edit.place.category.modal.component.html',
    styleUrls: ['./edit.place.category.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EditPlaceCategoryModalComponent extends BaseComponent {

    public place: HubPlace;
    public hubName: string;
    public isUseDefault = true;
    public mergedDefaultCategories: { keys: string[], values: string[] }[];
    public clientPlaceCategories: PlaceType[] = [];
    public blockGooglePlaceCategories: string[] = [];
    public toggleAndSource = new HubVisitorToggleDataSource();

    @ViewChild('selector') selector: PlaceCategorySelectorComponent;

    constructor(private dialogRef: MatDialogRef<EditPlaceCategoryModalComponent>,
                private actions: EditPlaceCategoryModalActions,
                private hubApiService: HubApiService,
                private visitorApiService: VisitorApiService,
                public imageService: ImageService,
                private alertify: AlertifyService,
                private toggleAndDataSourceStore: ToggleAndDataSourceStore,
                data: HubPlace) {
        super();
        this.place = Object.assign({}, data);
        this.hubName = this.place.hubName;

        this.loadCustomCategories();
    }

    public remove(categoryTitle: string) {
        categoryTitle = PlaceService.toCategoryCode(categoryTitle);
        if (this.place.categoryList.indexOf(categoryTitle) >= 0) {
            this.place.categoryList = this.place.categoryList.filter(x => x !== categoryTitle);
            this.place.category = this.place.categoryList.join(', ');
            const readable = this.place.categoryList.map(x => PlaceService.toReadableCategory(x));
            this.place.categoryText = readable.join(', ');
        }
    }

    public async confirm(event: ButtonTriggerEvent) {
        console.log(this.place);

        this.actions.confirm(event, {
            category: this.place.category,
            categoryList: this.place.categoryList,
            categoryText: this.place.categoryText
        });
        this.dialogRef.close();
    }


    public close(): void {
        if (this.actions.cancel) {
            this.actions.cancel();
        }

        this.dialogRef.close();
    }

    public loadCustomCategories() {       
        this.visitorApiService.getCustomDefaultPlaceCategories(this.hubName).subscribe(customDefaultPlaceCategory => {
            console.log('category in create place', customDefaultPlaceCategory);

            this.isUseDefault = customDefaultPlaceCategory.customDefaultPlaceCategory.useDefault;
            this.clientPlaceCategories = customDefaultPlaceCategory.customDefaultPlaceCategory.customCategories;

            this.toggleAndSource.toggle = customDefaultPlaceCategory.toggle;
            this.toggleAndSource.dataSource.businessType = customDefaultPlaceCategory.dataSource.businessType;
            this.mergedDefaultCategories = customDefaultPlaceCategory.mergedDefaultCategories.filter(x => x.forBusinessTypes.indexOf(this.toggleAndSource.dataSource.businessType) >= 0);

            this.blockGooglePlaceCategories = customDefaultPlaceCategory.blockGooglePlaceCategories ?
                customDefaultPlaceCategory.blockGooglePlaceCategories.split(', ').map(x => PlaceService.toReadableCategory(x)) : [];

            console.log('this.clientPlaceCategories', this.clientPlaceCategories);
        });
    }

    public isSelected(categoryTitle: string) {
        return this.place.categoryList.indexOf(categoryTitle) >= 0;
    }

    public normalCategorySelected(categoryTitle: string) {
        categoryTitle = PlaceService.toCategoryCode(categoryTitle);
        if (this.place.categoryList.indexOf(categoryTitle) >= 0) {
            this.place.categoryList = this.place.categoryList.filter(x => x !== categoryTitle);
        } else {
            this.place.categoryList.push(categoryTitle);
        }
        this.place.category = this.place.categoryList.join(', ');
        const readable = this.place.categoryList.map(x => PlaceService.toReadableCategory(x));
        this.place.categoryText = readable.join(', ');
    }

    public toReadable(code: string) {
        return PlaceService.toReadableCategory(code);
    }

    public toCode(category: string) {
        return PlaceService.toCategoryCode(category);
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.place.category.modal/edit.place.category.modal.component.ts